import IconDelete from '@mnd-frontend/icons/components/Delete';
import { Button } from '@mnd-frontend/ui/publish/components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CloudinaryImage from '../../../components/CloudinaryImage';
import { ImageAspectRatio } from '../constants';

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const ImagePreviewWrapper = styled.div`
  height: 100%;
  width: 100%;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  aspect-ratio: ${ImageAspectRatio.Standard_4_3};

  img {
    width: 100%;
    height: auto;
    align-self: center;
  }
`;

const ButtonsWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 0.5rem;
  right: 0.5rem;
`;

type Props = { imageUrl?: string } & any;

const VideoUploadPreview = ({
  imageUrl,
  disabled,
  isDraft,
  error,
  onChange,
  handleFileDelete,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <ButtonsWrapper>
        {!error && isDraft && (
          <Button
            type="button"
            onClick={handleFileDelete}
            aria-label={t('common.remove')}
            disabled={disabled}
            icon={<IconDelete />}
          />
        )}
        {!error && !isDraft && onChange && (
          <Button configuration="toned" type="button" onClick={onChange}>
            {t('components_file-upload_replace-video')}
          </Button>
        )}
      </ButtonsWrapper>
      <ImagePreviewWrapper>
        <CloudinaryImage imageUrl={imageUrl} alt={t('common_image-preview')} />
      </ImagePreviewWrapper>
    </Wrapper>
  );
};
export default VideoUploadPreview;
